import Link from 'next/link';
import Image from 'next/image';
import React from 'react';
import { JobDetail } from '~/types/job-detail';

interface RecommendedJobsProps {
  jobs: JobDetail[];
  otherWatchedJobsPresent: boolean;
}

const RecommendedJobs: React.FC<RecommendedJobsProps> = ({
  jobs,
  otherWatchedJobsPresent,
}) => {
  const refParam = otherWatchedJobsPresent
    ? 'jobs_sidebar_related_histories'
    : 'jobs_sidebar_attention';

  return (
    <div className="c-panel -sidebar">
      <h2 className="c-panel__header">
        {otherWatchedJobsPresent
          ? '閲覧履歴に基づくおすすめの求人'
          : 'おすすめの求人'}
      </h2>
      <div className="c-panel__body">
        <div className="p-useful-contents">
          {jobs.map((job) => {
            const imageUrl =
              job.media_info.image_url && job.media_info.image_url.length > 0
                ? job.media_info.image_url
                : `/nextjs/images/sample_images/image${
                    (job.id % 9) + 1
                  }_small.webp`;

            return (
              <Link
                href={`/jobs/${job.id}?ref=${refParam}`}
                key={job.id}
                className="p-useful-contents__item u-w-full"
                prefetch={false}
              >
                <div className="p-useful-contents__item__image -h64">
                  <Image
                    src={imageUrl}
                    alt={job.title}
                    width={240}
                    height={160}
                    loading="lazy"
                    className="object-cover w-full h-full"
                    unoptimized
                  />
                </div>

                <div className="p-useful-contents__item__main">
                  <div className="u-color-gray-light2 u-fs11">
                    {job.display_company_info && job.company
                      ? job.company.name.length > 17
                        ? job.company.name.slice(0, 17) + '…'
                        : job.company.name
                      : '社名非公開'}
                  </div>

                  <div className="p-useful-contents__item__main__title u-h-auto">
                    {job.title.length > 16
                      ? job.title.slice(0, 16) + '…'
                      : job.title}
                  </div>
                  {job.employment_info.annual_salary && (
                    <div className="flex items-center u-pt2">
                      <Image
                        src="/nextjs/images/icons/ic_money.svg"
                        alt="annual-salary"
                        width={12}
                        height={12}
                        loading="lazy"
                      />
                      <span className="u-color-red u-fs12 u-font-bold u-ml3">
                        {(() => {
                          const [num] =
                            job.employment_info.annual_salary.split('万円');
                          return (
                            <>
                              {num}
                              {num && (
                                <span className="u-color-red u-fs12 u-font-bold">
                                  万円
                                </span>
                              )}
                            </>
                          );
                        })()}
                      </span>
                    </div>
                  )}

                  <div className="u-flex u-align-center u-gap10 u-fs11 u-ml1">
                    <div className="job-prefecture flex items-center">
                      <Image
                        src="/nextjs/images/icons/ic_location.svg"
                        alt="location"
                        width={11}
                        height={11}
                        loading="lazy"
                        className="p-useful-contents__item-align-bottom"
                      />
                      <span className="u-ml2">
                        {job.location_info.prefecture?.name}
                      </span>
                    </div>

                    <div className="job-categories flex items-center">
                      <Image
                        src="/nextjs/images/icons/ic_bag.svg"
                        alt="category"
                        width={11}
                        height={11}
                        loading="lazy"
                        className="p-useful-contents__item-align-bottom"
                      />
                      <span className="u-ml2">
                        {job.category_info.categories &&
                        job.category_info.categories[0]?.name
                          ? job.category_info.categories[0].name.length > 8
                            ? job.category_info.categories[0].name.slice(0, 8) +
                              '…'
                            : job.category_info.categories[0].name
                          : ''}
                      </span>
                    </div>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default RecommendedJobs;
